import { JSX } from "react";
import { useTranslation } from "react-i18next";

import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListSubheader from "@mui/material/ListSubheader";
import Typography from "@mui/material/Typography";

import { asTitle } from "utils/Utils";

import { OrganisationOverview } from "organisation/OrganisationTypes";
import { getLogo } from "organisation/OrganisationUtils";

export type SelectOrganisationFormProps = {
	organisations: Array<OrganisationOverview>;
	selectedOrganisation?: number;

	onSelectOrganisation: (id: number) => void;
	onCreateOrganisation: () => void;
};

export default function SelectOrganisationForm(
	props: Readonly<SelectOrganisationFormProps>
): JSX.Element {
	const { t } = useTranslation();

	return (
		<List
			subheader={
				<ListSubheader>
					{asTitle(t("selectOrganisation"))}
				</ListSubheader>
			}>
			{props.organisations
				.sort((a, b) => a.name.localeCompare(b.name))
				.map(org => (
					<ListItemButton
						key={org.id}
						selected={props.selectedOrganisation === org.id}
						onClick={() => props.onSelectOrganisation(org.id)}>
						<ListItemIcon>{getLogo(org)}</ListItemIcon>
						<ListItemText primary={org.name} />
					</ListItemButton>
				))}
			<ListItemButton
				aria-label="create-organisation"
				onClick={props.onCreateOrganisation}>
				<Typography variant="subtitle2">
					{`+ ${asTitle(t("createOrganisation"))}`}
				</Typography>
			</ListItemButton>
		</List>
	);
}
